import React, {useContext, useState} from 'react';
import STC from '../../../../../../STCLibrary/STCFactory/STCFactory';
import { PassengerAPI } from '../../../../../../API/PassengerAPIs/PassengerAPIs';
import DropDown from '../../../../../../STCLibrary/DropDown/DropDown';
import { useNavigate, useParams } from 'react-router-dom';
import './PassengerForm.css'
import Form from 'react-bootstrap/Form';
import { FaQuestionCircle } from 'react-icons/fa';
import ApiResponseHandler from '../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import { format, subMonths, subYears, isAfter } from 'date-fns';
import ColouredLoadingSymbol from '../../../../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';

export default function PassengerForm({passenger, handleSuccess}){
 
    const routeParams = useParams();
    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();
 
    const [sending, setSending] = useState(false);
    const [sendingCreatePax, setSendingCreatePax] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [invalid, setInvalid] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [genderInfo, setGenderInfo] = useState(false);
 
    const [tourDetails, setTourDetails] = useState({});
    const [firstName, setFirstName] = useState(passenger?.firstName ?? '');
    const [surname, setSurname] = useState(passenger?.surname ?? '');
    const [dob, setDob] = useState(passenger?.dateOfBirth ?? '');
    const [gender, setGender] = useState(passenger?.gender ?? '');
    const [bookingID, setBookingID] = useState('');
    const [dest, setDest] = useState(passenger?.gender ?? '');
    const [termsAccepted, setTermsAccepted] = useState(false);
 
    const minDate = new Date(new Date().getFullYear() - 100, new Date().getMonth(), new Date().getDate())
    .toISOString()
    .split("T")[0];
    const maxDate = format(subMonths(new Date(), 6), 'yyyy-MM-dd');
 
 
    const createPassenger = () => {
        setSendingCreatePax(true);
        const postJSON = {
            id: passenger?.id ?? null, 
            payerId: parseInt(routeParams.userID),
            firstName: firstName,
            surname: surname,
            dateOfBirth: dob,
            gender: gender,
            active: true,
            passengerType: 'PAYMENT_ACCOUNT',
            passport: passenger?.passport ?? null
        }
        
        PassengerAPI.PostRegisterPassengerTour(bookingID, postJSON)
        .then((response) => {
            if(response.status === 200){
                setSending(false);
                handleSuccess();
                ApiResponseHandler(response, notificationCtx, navigate);
            }
        })
        .catch((err) => {
            console.log(err);
            setSending(false);
            setInvalid(true);
            setErrorMsg('Error connecting to server. Please try again later.')
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
        .finally(() => {
            setShowModal(false);
            setSending(false);
            setSendingCreatePax(true);
        })
    }


    const handleSubmit = async (e) => {
        try{
            e.preventDefault();
            e.stopPropagation();
            setSending(true);
            setInvalid(false);
            const tour  = await PassengerAPI.GetTourDetails(bookingID).catch((err) => console.log(err));
            setTourDetails(tour.data);
            if(tour.data.destinations){
            
            // const validTour = tour.data.destinations[0] === dest;
            const validTour = tour.data.destinations.includes(dest);
            
            if(validTour){
                setShowModal(true);
            }
            else{
                setErrorMsg('Selected Destination must match destination of Booking ID');
                setInvalid(true);
                setSending(false);
            }
        }
        
        
        }
        catch (err){
            setSending(false);
            setInvalid(true);
            setErrorMsg('Error connecting to server. Please try again later.');
            ApiResponseHandler(err.response, notificationCtx, navigate);
        }
    }

    const handleClickConfirm = async () => {
        createPassenger();
    }

    const handleClickCancel = () => {
        setShowModal(false);
        setSending(false);
    }
   
    async function handleTestSubmit(e){
 
        e.preventDefault();
        e.stopPropagation();

        
 
        const tour  = await PassengerAPI.GetTourDetails(bookingID).catch((err) => console.log(err));
        setTourDetails(tour.data);
        setSending(true);
        setInvalid(false);
       try{
        if(tour.data.destinations){
            
            const validTour = tour.data.destinations[0] === dest;
            if(validTour){
                setShowModal(true);
            }
            else{
                setErrorMsg('Selected Destination must match destination of Booking ID');
                setInvalid(true);
                setSending(false);
            }
        }
        else{
            setErrorMsg('Booking ID does not match an existing tour');
            setInvalid(true);
            setSending(false);
        }
    } catch (err){
        setSending(false);
        setInvalid(true);
        setErrorMsg('Error connecting to server. Please try again later.');
        ApiResponseHandler(err.response, notificationCtx, navigate);
    }
       
 
    }
 
    const handleClear = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFirstName('')
        setSurname('')
        setDob('')
        setGender('');
        setBookingID('')
        setDest('');
        setInvalid(false);
    }
 
    return(
        <>
        <STC.Form onSubmit={handleSubmit} onReset={handleClear}>
 
        {! passenger &&
        <>
            <STC.Alert variant={"warning"}>
                The passenger details below must be entered <strong>exactly</strong> as per passport or a change fee of minimum <strong>€115</strong> is applied.
            </STC.Alert>
            <STC.Form.Group>
            <STC.Form.FloatingLabel className="mb-3">
                <Form.Control
                    id="floatingInputFirstName"
                    placeholder="First Name"
                    required
                    disabled={sending}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                />
                <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputFirstName">Passenger First Name</label>
            </STC.Form.FloatingLabel>
            </STC.Form.Group>
 
            <STC.Form.Group>
            <Form.Floating className="mb-3">
                <Form.Control
                    id="floatingInputSurename"
                    placeholder="Surname"
                    required
                    disabled={sending}
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                />
                <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputSurename">Passenger Surname</label>
            </Form.Floating>
            </STC.Form.Group>
 
            <STC.Form.Group>
                <STC.Form.Label htmlFor='date-of-birth'>Passenger Date of Birth</STC.Form.Label>
                <STC.Form.Control  className='input-fields'
                    type='date'
                    required
                    id='date-of-birth'
                    disabled={sending}
                    value={dob}
                    max={maxDate}
                    min={minDate}
                    onChange={(e) => setDob(e.target.value)}
                />
            </STC.Form.Group>
 
            <STC.Form.Group className='mb-2'>
                <STC.Form.Label htmlFor='gender-dropdown'>Passenger Gender</STC.Form.Label>
                <STC.InputGroup>
                <STC.Form.Select  className='input-fields'
                    id='gender-dropdown'
                    required
                    disabled={sending }
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                   
                >
                    <option  value={''}>Gender</option>
                    <option value={'M'}>Male</option>
                    <option value={'F'}>Female</option>
                </STC.Form.Select>
                <STC.Button type='button' onClick={() => setGenderInfo(!genderInfo)}><FaQuestionCircle/></STC.Button>
                </STC.InputGroup>
            </STC.Form.Group>

            {genderInfo &&
                <STC.Alert>
                    Gender preference - Airlines require all passengers to indicate their sex as it appears on their passport for airline booking purposes.  Should your child have a different gender preference, please inform the group leader who will make us aware of this for accommodation purposes.
                </STC.Alert>
            }
            </>
 
        }
            <Form.Floating className="mb-3">
                <Form.Control
                    id="floatingInputBookingID"
                    placeholder="Booking ID"
                    required
                    disabled={sending}
                    isInvalid={invalid}
                    value={bookingID}
                    type='number'
                    onChange={(e) => setBookingID(e.target.value)}
                />
                <label htmlFor="floatingInputBookingID">Booking ID</label>
            </Form.Floating>
           
 
            <STC.Form.Group className='mb-2'>
                <STC.Form.Label>Destination</STC.Form.Label>
                <DropDown.Destination className='input-fields'
                    required
                    disabled={sending}
                    isInvalid={invalid}
                    value={dest}
                    onChange={(e) => setDest(e.target.value)}
                />
            </STC.Form.Group>
            <STC.Alert variant={"warning"}>
                Visas for all destinations must be obtained by the passenger themselves. The School Tour Company is not responsible for the organisation of Visas for travelling passengers.
            </STC.Alert>
 
            {invalid &&<STC.Alert variant={'danger'}>
                {errorMsg}
            </STC.Alert>}
            <div className="mb-3">
                <STC.Form.Check
                    type="checkbox"
                    id="termsAndConditions"
                    label={
                        <>
                            I agree to the{' '}
                            <a href="https://schooltour.ie/booking-conditions/" target="_blank" rel="noopener noreferrer">
                                Terms and Conditions
                            </a>
                        </>
                    }
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    required
                />
            </div>

            <div className='add-passenger-button-line'>
                <STC.Button disabled={sending || !termsAccepted} className="submit" type='submit'>
                    {sending ? 'Submitting...' : 'Submit'}
                </STC.Button>
            </div>

            <div className='add-passenger-button-line'>
                <STC.Button disabled={sending} className='clear' type='reset'>Clear</STC.Button>
            </div>
        </STC.Form>
        
        <STC.Modal className='confirm-form-modal' show={showModal} onHide={() => {if(!sending){setShowModal(false)}}}>
            <STC.Modal.Header className='confirm-header'><strong>{tourDetails.schoolName} | {tourDetails.destinations && tourDetails.destinations.map((dest) => dest)}</strong></STC.Modal.Header>
            <STC.Modal.Body>
                {!sendingCreatePax && 
                    <div>
                        <div>Do you wish to {passenger ?'add' : 'create'} this passenger {!passenger && 'and add them'} to this tour?
                        </div>

                        <STC.Row className='m-2'>
                            <STC.Col sm={3}><strong>Name</strong></STC.Col>
                            <STC.Col>{firstName} {surname}</STC.Col>
                        </STC.Row>

                        <STC.Row className='m-2'>
                            <STC.Col sm={3}><strong>DOB</strong></STC.Col>
                            <STC.Col>{dob}</STC.Col>
                        </STC.Row>

                        <STC.Row className='m-2'>
                            <STC.Col sm={3}><strong>Gender</strong></STC.Col>
                            <STC.Col>{gender === 'M' ? 'Male' : 'Female'}</STC.Col>
                        </STC.Row>
                    </div>}
                {sendingCreatePax &&
                    <div className='message-container'>
                                <ColouredLoadingSymbol  />
                                </div>
                }
            </STC.Modal.Body>
            <STC.Modal.Footer>
                <STC.Button className='clear' disabled={sendingCreatePax} variant='secondary' onClick={() => handleClickCancel()}>Cancel</STC.Button>
                <STC.Button className='confirm' disabled={sendingCreatePax} onClick={() => handleClickConfirm()}>{sendingCreatePax ? 'Confirming...' : 'Confirm'}</STC.Button>
            </STC.Modal.Footer>
        </STC.Modal>
        
        </>
    );
}
 